var _style, _circle, _circle2, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFundavollLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 354.48 352.41",
    style: {
      enableBackground: "new 0 0 354.48 352.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EAE0C0;stroke:#0E2538;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#EAE0C0;stroke:#0E2538;stroke-width:5;stroke-miterlimit:10;}\n\t.st2{fill:#0E2538;}\n\t.st3{font-family:'Salamat';}\n\t.st4{font-size:70.9053px;}\n\t.st5{font-size:19.1501px;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 177.05,
    cy: 176.67,
    r: 170.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 177.05,
    cy: 176.67,
    r: 155.91
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7041 4.778288e-03 -6.786509e-03 1 47.0617 174.7587)",
    className: "st2 st3 st4"
  }, "Fundavoll")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9285 0 0 1 147.1736 226.9868)",
    className: "st2 st3 st5"
  }, "by Funda Bilgic")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundavollLogo);
export default __webpack_public_path__ + "static/media/fundavoll_logo.5769a9cd3b08a4bd69001669d688add1.svg";
export { ForwardRef as ReactComponent };